import React, { useMemo } from "react"
import { IconProps } from "types/icon"

const SquareStar: React.FC<{ fill?: 0 | 50 | 100, rating?: number } & IconProps> = ({
    size = "16",
    color = "#f15c4f",
    fill = 0,
    rating = 0,
    ...attributes
}) => {

    const backgroundColor = useMemo(() => {
        if (rating < 1.8) return "#ffcc4b";
        if (rating < 2.8) return "#ffad48";
        if (rating < 3.8) return "#ff8742";
        if (rating < 4.8) return "#ff643d";
        return "#fb433c";
    }, [rating]);

    let rectFillWidth = "20"
    if (fill === 50) rectFillWidth = "10"
    if (fill === 0) rectFillWidth = "0"

    const isHalfStar = rectFillWidth == '10';

    return (
        <>
            {isHalfStar && <svg width="0" height="0" style={{ position: 'absolute' }}>
                <defs>
                    <clipPath id="round-corner">
                        <rect x="0" y="0" width="20" height="20" rx="3" ry="3" />
                    </clipPath>
                </defs>
            </svg>}
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 20 20"
                width={size}
                height={size}
                className={`relative cursor-pointer`}
                {...attributes}
            >
                <rect width="20" height="20" rx="3" className="fill-gray-600" />
                <rect
                    width={rectFillWidth}
                    height="20"
                    rx={isHalfStar ? 0 : 3}
                    className="absolute right-0 top-0"
                    clipPath={isHalfStar ? "url(#round-corner)" : ''}
                    fill={backgroundColor}
                />
                <path 
                d="M 7.5 1.113281 C 6.84375 1.113281 5.550781 4.34375 5.019531 4.730469 C 4.488281 5.117188 1.015625 5.347656 0.8125 5.972656 C 0.609375 6.597656 3.285156 8.824219 3.488281 9.449219 C 3.691406 10.074219 2.835938 13.445312 3.367188 13.832031 C 3.898438 14.21875 6.84375 12.363281 7.5 12.363281 C 8.15625 12.363281 11.101562 14.21875 11.632812 13.832031 C 12.164062 13.445312 11.308594 10.074219 11.511719 9.449219 C 11.714844 8.824219 14.390625 6.597656 14.1875 5.972656 C 13.984375 5.347656 10.511719 5.117188 9.980469 4.730469 C 9.449219 4.34375 8.15625 1.113281 7.5 1.113281 Z M 7.5 1.113281 " 
                fill="white" 
                transform="translate(2,2)"/>
            </svg>
        </>
    )
}

export default SquareStar
